// How the admin pages label the language a respondent filled an instrument in.
const NAMES = {
  id: { id: "Indonesia", en: "Indonesian" },
  en: { id: "Inggris", en: "English" },
};

export function responseLanguageLabel(response, uiLang = "id") {
  const language = response?.language;
  if (!language) return uiLang === "id" ? "Tidak diketahui" : "Unknown";
  const used = response.languages_used || [];
  if (response.language_switched && used.length > 1) {
    return used.map((code) => code.toUpperCase()).join(" → ");
  }
  return language.toUpperCase();
}

export function responseLanguageName(code, uiLang = "id") {
  return NAMES[code]?.[uiLang] || code || (uiLang === "id" ? "Tidak diketahui" : "Unknown");
}
